import React, { useEffect, useState } from "react";

export const ScrollProgress = () => {
    const [pct, setPct] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const height =
                document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const next = height > 0 ? (scrollTop / height) * 100 : 0;
            setPct(Math.min(100, Math.max(0, next)));
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, []);

    return (
        <div
            data-testid="scroll-progress-track"
            aria-hidden
            className="fixed top-0 left-0 right-0 h-[2px] z-[110] pointer-events-none bg-transparent"
        >
            <div
                data-testid="scroll-progress-bar"
                className="h-full bg-gold shadow-[0_0_10px_rgba(212,175,55,0.6)] transition-[width] duration-75 ease-linear"
                style={{ width: `${pct}%` }}
            />
        </div>
    );
};

export default ScrollProgress;
